<template>
  <button class="button button--toggle button--select" :class="{ 'is-active' : isActive }"><slot /></button>
</template>

<style scoped lang="scss">
  
</style>

<script>
  export default {
    name: 'ButtonSelect',

    props: {
      isActive: {
        type: Boolean,
        required: true
      }
    }
  };
</script>